module.exports = __webpack_public_path__ + "static/media/anniu5_hui.281b6b23.png";